import { Box, Container, Grid, Typography } from "@mui/material";
import { motion } from "framer-motion";
import theme from "../theme/theme";

const Content3 = () => {
  const companyValues = [
    { name: "Visa Documents Assistance", img: "/visaa.webp" },
    { name: "Hotel Booking", img: "/hotel.webp" },
    { name: "Inbound Trips", img: "/trips.png" },
    { name: "Air ticket booking Assistance", img: "/ticket.webp" },
    { name: "Travel Insurance", img: "/travel.webp" },
    { name: "& Much more", img: "/more.webp" },
  ];

  return (
    <Container id="services">
      <Box>
        <Typography
          variant="h4"
          sx={{
            fontSize: "2.5rem",
            fontWeight: 700,
            color: theme.palette.primary.main,
            fontFamily:'Emirates',

            textTransform: "uppercase",
            textAlign: "center",
            py: 2,
          }}
        >
          Our Services
        </Typography>

        <Grid container spacing={2}>
          {companyValues.map((value, index) => (
            <Grid key={index} item xs={12} md={4} lg={4}>
              <motion.div
                initial={{ opacity: 0, y: 50, scale: 0.9 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                viewport={{ once: false, amount: 0.2 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
              >
                <Box sx={{ padding: "20px", textAlign: "center" }}>
                  <Box
                    sx={{
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      height: "70px",
                      width: "70px",
                      padding: "20px",
                      borderRadius: "50%",
                      margin: "auto",
                      backgroundImage: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.light}, ${theme.palette.primary.dark})`,
                    }}
                  >
                    <img
                      src={value.img}
                      alt={value.name}
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                  <Typography
                    variant="h5"
                    sx={{ fontSize: "1.5rem", color: theme.palette.primary.main ,
                      fontFamily:'Emirates',

                    }}
                  >
                    {value.name}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontSize: "1.1rem", color: "gray" }}
                  >
                    {value.description}
                  </Typography>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default Content3;
